import React from 'react';
import { ConfigProvider } from 'antd';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AuthProvider from './components/Auth/AuthProvider';
import ProtectedRoute from './components/Auth/ProtectedRoute';
import AdminProtectedRoute from './components/Auth/AdminProtectedRoute';
import RedirectHandler from './components/Auth/RedirectHandler';
import HomePage from './pages/Landing/HomePage';
import MainPage from './pages/Landing/MainPage';
import DetailPage from './pages/Landing/DetailPage';
import AdminHomePage from './pages/Admin/HomePage';
import ContentManagement from './pages/Admin/ContentManagement';
import './App.css'
import ContentDetail from './pages/Admin/ContentManagement/detail';
import DxManagement from './pages/Admin/DXManagement';
import DxDetail from './pages/Admin/DXManagement/detail';
import { LanguageProvider } from './contexts/LanguageContext';
import Error from './pages/Admin/Error';

const App: React.FC = () => {
  return (
    <LanguageProvider>
      <AuthProvider>
        <ConfigProvider
          theme={{
            token: {
              colorPrimary: '#4797ffff',
              fontFamily: "'SCG Regular', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
            },
          }}
        >
        <Router>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route
              path="/admin"
              element={
                <AdminHomePage />
              }
            />
            <Route
              path="/admin/content-list"
              element={
                <AdminProtectedRoute>
                  <ContentManagement />
                </AdminProtectedRoute>
              }
            />
            <Route
              path="/admin/content-list/:id"
              element={
                <AdminProtectedRoute>
                  <ContentDetail />
                </AdminProtectedRoute>
              }
            />
            <Route
              path="/admin/dx-list"
              element={
                <AdminProtectedRoute>
                  <DxManagement />
                </AdminProtectedRoute>
              }
            />
            <Route
              path="/admin/dx-list/:id"
              element={
                <AdminProtectedRoute>
                  <DxDetail />
                </AdminProtectedRoute>
              }
            />
            <Route
              path="/redirect"
              element={<RedirectHandler />}
            />
            <Route
              path="/main"
              element={
                <MainPage />
              }
            />
            <Route
              path="/detail/:id"
              element={
                <DetailPage />
              }
            />
            <Route
              path="/error"
              element={
                <ProtectedRoute>
                  <Error/>
                </ProtectedRoute>
              }
            />
          </Routes>
        </Router>
      </ConfigProvider>
    </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
